<template>
    <el-card class="box-card">
        <!-- 表单只有一个文本框的时候，按回车会自动submit表单，需要禁用sunmit -->
        <el-form
            ref="searchform"
            :inline="true"
            :model="form"
            @submit.native.prevent
            size="medium"
        >
            <el-form-item label="企业名称" prop="name">
                <el-input
                    v-model="form.name"
                    placeholder="客户名称搜索"
                    @keyup.enter.native="search()"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item label="企业类型" prop="type">
                <el-select
                    v-model="form.type"
                    placeholder="选择类型"
                    class="typec"
                    clearable
                >
                    <el-option
                        label="客户"
                        :value=0
                    ></el-option>
                    <el-option
                        label="供应商"
                        :value=1
                    ></el-option>
                    <el-option
                        label="我方企业"
                        :value=2
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="合作状态" prop="status">
                <el-select
                    v-model="form.status"
                    placeholder="选择状态"
                    class="statusc"
                    clearable
                >
                    <el-option
                        label="禁用"
                        :value=0
                    ></el-option>
                    <el-option
                        label="临时"
                        :value=1
                    ></el-option>
                    <el-option
                        label="长期"
                        :value=2
                    ></el-option>
                    <el-option
                        label="备用"
                        :value=3
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="联系人" prop="contacts">
                <el-input
                    v-model="form.contacts"
                    placeholder="联系人搜索"
                    @keyup.enter.native="search()"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain @click="search">搜索</el-button>
                <el-button type="warning" plain @click="resetbtn('searchform')"
                    >重置</el-button
                >
            </el-form-item>
            <el-button
                v-if="$_has(add_auth)"
                type="success"
                plain
                round
                @click="addTeam"
                class="temp_add"
                size="medium"
                >添加企业</el-button
            >
        </el-form>
    </el-card>
</template>

<script>
export default {
    name: 'ClientSearchBarComponent',
    data() {
        return {
            fdialogFormVisible: false,
            form: {
                name: '',
                type: '',
                status: '',
                contacts: '',
                page: 1,
            }
        }
    },
    computed: {},
    methods: {
        search() {
            this.$emit('search', this.form)
        },
        resetbtn(f) {
            this.$refs[f].resetFields()
        },
        addTeam() {
            this.$emit('addTeam')
        },
    },
    filters: {},
    props: {
        add_auth: String
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch: {},
}
</script>

<style>
.temp_add {
    float: right;
    margin-bottom: 10px;
}
.typec {
    width: 150px;
}
</style>